<template>
  <section class="article event" style="overflow-y: auto;">
    <div class="article-wrap" v-if="event">
      <div class="article-content">
        <div class="event-header" :style="{ backgroundImage: 'url(' + getCover() + ')' }">
          <div class="event-buttons">
            <div class="event-back event-back_list" @click="backToList()">
              <font-awesome-icon icon="list-ul" />
              <p>Показать список</p>
            </div>
            <div
              class="event-back event-back_map"
              v-if="event.place || (event.latitude && event.longitude)"
              @click="backToMap()"
            >
              <font-awesome-icon icon="map" />
              <p>Показать на карте</p>
            </div>
            <div class="event-back event-back_map" v-else @click="backToMap()">
              <font-awesome-icon icon="map-marker-alt" />
              <p>На карту</p>
            </div>
          </div>
          <div class="event-invited" v-if="youInvited && !hasUser">Вы приглашены</div>
          <div class="event-invited" v-if="event.max_users <= event.users.length">Максимум участников достигнут</div>

          <!-- Главная кнопка -->
          <div
            class="event-join joined"
            v-if="isAuthor"
          >
            {{ 'Это ваше событие' }}
          </div>
          <div
            class="event-join"
            v-if="hasUser && !isAuthor && !isClosed"
            @click="joinToEvent()"
            :class="{ joined: hasUser === true }"
          >
            {{ 'Вы участник' }}
          </div>
          <div
            class="event-join"
            v-if="hasUser && !isAuthor && isClosed"
            :class="{ joined: hasUser === true }"
          >
            {{ 'Вы были здесь' }}
          </div>
          <div
            class="map-button event-join"
            v-if="!isClosed && !hasUser && event.max_users > event.users.length"
            @click="joinToEvent()"
            :class="{ joined: hasUser === true }"
          >
            {{ 'Присоединиться' }}
          </div>
          <div class="event-time" v-if="notStarted">
            Начнется {{ getLeftTime }}
          </div>
          <div class="event-time" v-if="isClosed">
            Событие завершено
          </div>
          <div 
            class="event-started" 
            @click="full_status = !full_status" 
            :class="{open: full_status}"
            v-if="!notStarted && !isClosed"
          >
            <p>Закончится {{ getTimeClose }}</p>
            <div class="event-started__pulse"></div>
          </div>

          <!-- Участники -->
          <div class="event-users" v-if="event.users">
            <!-- Автор -->
            <router-link
              :to="'/user/' + event.author.id"
              class="event-users__user"
              :style="{ backgroundImage: 'url(' + event.author.avatar + ')' }"
              :title="event.author.name"
            >
              <span></span>
            </router-link>

            <!-- Участники -->
            <router-link
              :to="'/user/' + user.id"
              class="event-users__user"
              v-for="user in event.users"
              :key="user.id"
              :style="{ backgroundImage: 'url(' + user.avatar + ')' }"
              :title="user.name"
            ></router-link>

            <!-- Все участники -->
            <div v-if="event.users.length > 7" class="event-users__more" @click="openParty()">
              <p>+{{ event.users.length - 7 }}</p>
            </div>

            <!-- Добавить участника -->
            <div
              v-else-if="((isAuthor && event.max_users > event.users.length && !isClosed) || ((hasUser && event.users_can_add && !isClosed)) && event.max_users > event.users.length)"
              class="event-users__more"
              @click="$store.dispatch('changeState', { element: 'invite' })"
            >
              <img src="@/assets/images/icons/icon_plus.svg" alt="" />
            </div>
          </div>
        </div>

        <div class="content">
          <div class="content-wrap">
            <h1 class="event-title">{{ event.title }}</h1>
            <div class="event-info">
              <router-link
                :to="{ name: `place`, params: { hash: this.event.place.id + '&' +this.event.place.hash } }"
                class="event-info__place"
                v-if="this.event.place"
                >{{ event.place.title }}</router-link
              >
              <p
                @click="backToMap()"
                class="event-info__place"
                v-else-if="this.event.latitude && this.event.longitude"
              >
                {{ this.event.country && this.event.state ? this.event.country + ', ' + this.event.state : this.event.latitude + ', ' + this.event.longitude }}
              </p>
              <p class="event-info__place" v-else>Без места</p>
              <p class="event-info__item">{{ event.views + 1 }} просмотров</p>
              <p class="event-info__item">{{ getDate() }}</p>
              <p class="event-info__item" v-if="isClosed">Закончилось {{ getEnd() }}</p>
            </div>
            <div class="event-category" v-if="event.sports && event.sports.length > 0">
              <div
                @click="setCategoryFilter(cat)"
                v-for="cat in event.sports"
                :key="cat.id"
                class="event-category__item"
                :class="cat.color"
              >
                {{ cat.ru }}
              </div>
            </div>
            <div class="content-body">
              <!-- eslint-disable -->
              <slot v-for="(element, index) in event.content">
                <p v-if="element.type == 'paragraph'" :key="index" v-html="getParagraph(element.value)"></p>
                <!-- <div v-if="element.type == 'block'" :key="index" v-html="element.value"></div> -->
                <h3 v-if="element.type == 'h3'" :key="index">{{element.value}}</h3>
                <div v-if="element.type == 'image'" :key="index" class="content-images">
                  <div class="content-images__image" :class="getImageClass(element.value)" v-for="(image, index_image) in element.value" :key="index_image" @click="showFullPhoto(element.value, index_image)">
                    <img :src="image.url" />
                  </div>
                </div>
                <iframe width="100%" height="450" :src="element.value" title="YouTube video player" v-if="element.type == 'youtube'" :key="index" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              
              </slot>
              <!-- eslint-enable -->
            </div>
            <div class="event-panel">
              <div 
                class="map-button map-button_action" 
                @click="joinToEvent()"
                v-if="!isClosed && !hasUser && event.max_users > event.users.length" >
                <p>Присоединиться</p>
              </div>
              <Like 
                :active="hasLike" 
                :likes="event.likes" 
                :size="28"
                @click.native="sendLike()"
              />
              <div class="share" @click="sharing = !sharing">
                <Sharing 
                  v-if="sharing"
                  :link="'https://wiildwood.online'+$route.path"
                  :description="getDescription"
                  :title="event.title"
                  :position="'top'"
                  :media="event.cover"
                 />
                <Reply />
                <p>Поделиться</p>
              </div>
            </div>
          </div>
          <Comments placeholder="Напишите комментарий" :event="event" />
        </div>

        <!-- Трансляция -->
        <div class="block translation" v-if="event.photos && event.photos.length > 0">
          <h4>Трансляция</h4>
          <div class="block-body">
            <PhotoSlider :items="event.photos" :event="event" :canDelete="isAuthor" @deletePhoto="deletePhoto" />
          </div>
        </div>

        <!-- События автора -->
        <div class="block similar" v-if="event.author_events && event.author_events.length > 0">
          <h4>События этого автора</h4>
          <div class="block-body">
            <EventsAuthor :items="event.author_events" />
          </div>
        </div>

        <!-- События места -->
        <div class="block similar" v-if="event.place_events && event.place_events.length > 0">
          <h4>События этого места</h4>
          <div class="block-body">
            <EventsPlace :items="event.author_events" />
          </div>
        </div>
      </div>
    </div>
    <!-- Панель с кнопками -->
    <Panel 
      v-if="event"
      :event="event"
      @join="joinToEvent()"
      @setComplain="setComplain"
      @deleteEvent="$emit('deleteEvent')"
      :isAuthor="isAuthor"
      :hasUser="hasUser"
      :isClosed="isClosed" />
    <EventPseudo v-if="!event" />
  </section>
</template>

<script>

export default {
  props: {
    event: {
      type: Object,
    },
  },
  data() {
    return {
      ids: this.$router.currentRoute.params['id'],
      content: '',
      joined: false,
      sharing: false,
      full_status: false
    };
  },
  components: {
    PhotoSlider: () => import('@/components/Sliders/PhotoSlider'),
    EventsPlace: () => import('@/components/Sliders/EventsPlace'),
    EventsAuthor: () => import('@/components/Sliders/EventsAuthor'),
    Panel: () => import('./Panel'),
    Like: () => import('@/components/Lenta/Like'),
    Reply: () => import('@/components/Lenta/Reply'),
    Comments: () => import('@/components/Blocks/Comments'),
    Sharing: () => import('@/components/UI/Sharing'),
    EventPseudo: () => import('@/components/Pseudo/EventPseudo'),
  },
  computed: {
    isClosed() {
      return this.$moment().isAfter(this.event.closed_plan);
    },
    isAuthor() {
      return this.getUser ? Number(this.event.author_id) == Number(this.getUser.id) : null
    },
    notStarted() {
      return new Date(this.event.date_event) >= new Date()
    },
    getUser () {
      return this.$store.getters.getAuthUser
    },
    getDescription() {
      let description = this.event.content.find(block => block.type === 'paragraph');
      return description && description.value ? description.value : document.querySelector('meta[property="og:description"]').content;
    },
    youInvited() {
      let you = this.getUser;
      return you && this.event.invites
        ? this.event.invites.find((item) => item.id === you.id)
          ? true
          : false
        : false;
    },
    hasUser() {
      let users = this.event ? this.event.users : null;
      let current = this.getUser, result = null;
      if (current && Number(this.event.author_id) == Number(current.id)) { 
        result = true
      } else if (users && users.length > 0 && current ) {
        result = users.find((user) => Number(user.id) == Number(current.id)) ? true : false;
      } else {
        result = false
      }
      return result
    },
    hasLike() {
      let likes = this.event.likes ? this.event.likes : null;
      let current = this.getUser;
      return likes && likes.length > 0 && current
        ? likes.find((like) => like.author_id === current.id)
          ? true
          : false
        : false;
    },
    getLeftTime() {
      let date = this.$moment(this.event.date_event).locale('ru').calendar().toLowerCase();
      date = date.replace('следующую', 'сл.')
      date = date.replace('следующий', 'сл.')
      date = date.replace('следующее', 'сл.')
      date = date.replace('прошлую', 'прош.')
      return date
    },
    getTimeClose() {
      let date = this.$moment(this.event.closed_plan).locale('ru').calendar().toLowerCase();
      date = date.replace('следующую', 'сл.')
      date = date.replace('следующий', 'сл.')
      date = date.replace('следующее', 'сл.')
      date = date.replace('прошлую', 'прош.')
      return date
    },
    getLikes() {
      return this.event.likes ? this.event.likes.length : 0
    }
  },
  methods: {
    deletePhoto({photo, index}) {
      this.$store.dispatch('deleteImage', {key: photo.key ? photo.key : photo.url, event_photo: photo.id})
      .then(() => {
        this.event.photos.splice(index, 1)
      });
    },
    getParagraph(value) {
      return this.escapeLinks(value.replace(/\n/g, '<br>'))
    },
    escapeLinks(message) {
        const regexp = new RegExp(/([^"=]{2}|^)((https?|ftp):\/\/\S+[^\s.,> )\];'"!?])/);
        const subst = '$1<a href="$2" target="_blank">$2</a>'; 
        return message.replace(regexp, subst);
    },
    showFullPhoto(photos, active) {
      this.$store.dispatch('setPhotos', {photos: photos, active: active})
      this.$store.dispatch('setPhotosState', true)
    },
    getImageClass(images) {
      let result = '';
      switch (images.length) {
        case 1:
          result = 'size_one';
          break;
        case 2:
          result = 'size_two';
          break;
        case 3:
          result = 'size_tree';
          break;
        case 4:
          result = 'size_four';
          break;
        case 5:
          result = 'size_five';
          break;
        case 6:
          result = 'size_six';
          break;

        default:
          break;
      }
      return result;
    },
    openParty() {
      this.$store.dispatch('changeState', { element: 'party' });
    },
    setCategoryFilter(cat) {
      cat.active = true;
      this.$store.dispatch('changeSports', cat);
    },
    async joinToEvent() {
      if (this.getUser) {

        let event = {
          id: this.event.id,
          title: this.event.title,
          hash: this.event.hash,
          author_id: this.event.author_id
        };
        let user = {
          id: this.getUser.id,
          firstname: this.getUser.firstname,
          lastname: this.getUser.lastname,
          avatar: this.getUser.avatar
        };
        if (this.hasUser) {
          await this.$store.dispatch('leaveFromEvent', {
            event: this.event.id,
            user: this.getUser.id,
          }).then(() => {
            this.$store.dispatch('fetchEvent', { id: this.event.id });
            this.$store.dispatch('createNotification', {from_id: this.$store.getters.getAuthUser.id, user: this.event.author_id, event_id: this.event.id, type: 'leave_event'} )
          }).catch(error => {
            this.$dispatch('setError', {message: error})
          });
        } else {
          await this.$store.dispatch('joinToEvent', {
            event: event,
            user: user,
          }).then(() => {
            this.$store.dispatch('fetchEvent', { id: this.event.id });
              this.$store.dispatch('afterJoin', this.event.users_can_add);
              this.$store.dispatch('createNotification', {from_id: this.$store.getters.getAuthUser.id, user: this.event.author_id, event_id: this.event.id, type: 'join_event'} )
          }).catch(error => {
            this.$dispatch('setError', {message: error})
          });

        }
      } else {
        this.toLoginPlease()
      }
    },
    async sendLike() {
      await this.$store.dispatch('sendLike', {
        event: this.event
      });
      if (this.hasLike) {
        let finded = this.event.likes.find(like => like.author_id == this.getUser.id);
        this.event.likes.splice(this.event.likes.indexOf(finded, 0))
      } else {
        this.event.likes ? this.event.likes.push({author_id: this.getUser.id}) : this.event.likes = [this.getUser.id]
      }
    },
    setComplain(data) {
      this.getUser ? this.$emit('setComplain', data) : this.toLoginPlease()
    },
    backToMap() {
      this.$store.dispatch('setMapZoom', 14);
      this.$store.dispatch('changeList', false);
      this.$store.dispatch('changeMode', 'map');
    },
    backToList() {
      this.$router.push('/events');
      this.$store.dispatch('changeList', true);
    },
    getCover() {
      return this.event.cover
        ? this.event.cover
        : 'https://images.unsplash.com/photo-1576967646301-b68a028ea17a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1353&q=80';
    },
    getDate() {
      return this.$moment(this.event.date_event).locale('ru').format('DD MMM YYYY в hh:mm');
    },
    getEnd() {
      return this.$moment(this.event.closed_plan).locale('ru').format('DD MMM YYYY в hh:mm');
    },
    toLoginPlease() {
      this.$router.push('/login')
      this.$store.dispatch('addNotification', {message: 'Чтобы выполнить это действие, войдите со своим аккаунтом. 😉'})
    }
  },
  watch: {
    event() {
      this.likes = null
      this.event_el = document.querySelector('.event');
      this.event_el.scrollTop = 0;
    }
  }
};
</script>
